/* Styled By Grace — native Shopify cart (AJAX Cart API + Section Rendering API) */
(function () {
  'use strict';

  var openDrawerId = null;
  var lastFocus = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Drawers (cart + mobile menu) ---------- */
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    var overlay = $('[data-overlay-for="' + id + '"]');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
    document.body.classList.add('drawer-open');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openDrawerId = id;
    var focusable = drawer.querySelector('button, a[href], input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    return true;
  }

  function closeDrawer(id) {
    var drawer = document.getElementById(id || openDrawerId);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    var overlay = $('[data-overlay-for="' + drawer.id + '"]');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
    openDrawerId = null;
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(id)) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.getAttribute('data-drawer-close')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawerId) closeDrawer(openDrawerId);
  });

  /* ---------- Cart rendering ---------- */
  function renderSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    var current = document.getElementById('CartDrawer');
    if (fresh && current) {
      $('[data-cart-contents]', current).innerHTML = $('[data-cart-contents]', fresh).innerHTML;
      var p = $('.drawer-header p', current), fp = $('.drawer-header p', fresh);
      if (p && fp) p.textContent = fp.textContent;
    }
    var page = $('[data-cart-page]');
    if (page && fresh) page.innerHTML = $('[data-cart-contents]', fresh).innerHTML;
  }

  function updateCount() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        $$('[aria-controls="CartDrawer"]').forEach(function (el) { el.setAttribute('aria-label', 'Open cart, ' + cart.item_count + ' items'); });
      });
  }

  function showCartError(msg) {
    var el = $('[data-cart-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  function changeLine(line, quantity) {
    var wrap = $('[data-cart-contents]');
    var page = $('[data-cart-page]');
    if (wrap) wrap.classList.add('is-loading');
    if (page) page.classList.add('is-loading');
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showCartError(res.data.description || res.data.message); return; }
        renderSections(res.data.sections);
        return updateCount();
      })
      .catch(function () { showCartError('Something went wrong. Please refresh and try again.'); })
      .finally(function () {
        if (wrap) wrap.classList.remove('is-loading');
        if (page) page.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(parseInt(btn.getAttribute('data-qty-change'), 10), Math.max(0, parseInt(btn.getAttribute('data-qty'), 10)));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      changeLine(parseInt(input.getAttribute('data-qty-input'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      return;
    }
    var auto = e.target.closest('[data-auto-submit]');
    if (auto && auto.form) auto.form.submit();
  });

  /* ---------- Add to cart (product form + quick add) ---------- */
  function addToCart(form, button) {
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    var label = button && (button.querySelector('[data-add-label]') || button);
    var original = label ? label.innerHTML : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    return fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.data.description || res.data.message || 'Could not add to cart.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { alert(msg); }
          return;
        }
        renderSections(res.data.sections);
        return updateCount().then(function () { openDrawer('CartDrawer'); });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        if (label) label.innerHTML = original;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-product-form]') || form.matches('[data-quick-add]')) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      addToCart(form, e.submitter || form.querySelector('[type="submit"]'));
    }
  });

  /* ---------- Product page: variants, gallery, quantity ---------- */
  function money(cents) {
    var el = $('[data-money-format]');
    var fmt = (el && el.getAttribute('data-money-format')) || null;
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (fmt) return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
    return value;
  }

  function initProduct(root) {
    var jsonEl = root.parentNode.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var selects = $$('[data-option-index]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var avail = $('[data-availability]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var mainImg = $('[data-gallery-main] img', root);
    var qty = $('[data-product-qty]', root);

    function selectImage(src, alt, mediaId) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      if (alt) mainImg.alt = alt;
      $$('.gallery-thumbnail', root).forEach(function (t) { t.classList.toggle('selected', String(t.getAttribute('data-media-id')) === String(mediaId)); });
    }

    $$('.gallery-thumbnail', root).forEach(function (t) {
      t.addEventListener('click', function () { selectImage(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-media-id')); });
    });

    $$('[data-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
        qty.value = Math.max(1, v);
      });
    });

    function onChange() {
      var values = selects.map(function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        if (avail) { avail.textContent = 'Unavailable'; avail.classList.remove('in'); }
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (avail) { avail.textContent = variant.available ? 'Available' : 'Sold out'; avail.classList.toggle('in', variant.available); }
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { compareEl.textContent = money(variant.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (variant.featured_media) {
        var thumb = $('.gallery-thumbnail[data-media-id="' + variant.featured_media.id + '"]', root);
        if (thumb) selectImage(thumb.getAttribute('data-src'), thumb.getAttribute('data-alt'), variant.featured_media.id);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', onChange); });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el || el.children.length) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-product-root]').forEach(initProduct);
    initRecommendations();
  });
})();
